// ---------------------------------------------------
//              Training Pending Types
// ---------------------------------------------------

export interface PendingTraining {
    Name?: string;
    trainingType?: number;
    trainer?: number;
    Attendees?: number[];
    mode?: "online" | "offline";
    location?: string;
    trainingCost?: number;
    StartDate?: string;
    EndDate?: string;
    Status?: "active" | "inactive";
    Description?: string;
    days?: string[];
}

export interface PendingDeleteTraining {
    awaitingName?: boolean;
}


export const startCreateTrainingFlow = (
    setPendingTraining: (data: PendingTraining | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        setPendingTraining({ Name: nameFromIntent });

        pushAIChat(`Creating training "${nameFromIntent}". What is the training type?`);
        speak(`Creating training ${nameFromIntent}. What is the training type?`);
        return;
    }

    setPendingTraining({});
    pushAIChat("What should be the training name?");
    speak("What should be the training name?");
};

export const processPendingTraining = (
    text: string,
    pending: PendingTraining,
    setPendingTraining: (data: PendingTraining | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    helpers: {
        activeEmployee: any[];
    }
) => {

    // Name
    if (!pending.Name) {
        const clean = text.trim();
        if (!clean) {
            pushAIChat("Please provide a valid training name.");
            speak("Please provide a valid training name.");
            return;
        }

        setPendingTraining({ ...pending, Name: clean });
        pushAIChat("What is the training type?");
        speak("What is the training type?");
        window.dispatchEvent(
            new CustomEvent("ai-suggest-options", {
                detail: { type: "trainingType" }
            })
        );
        return;
    }

    // // Training Type
    // if (!pending.trainingType) {
    //     // pushAIChat("Please select the training type.");
    //     // speak("Please select the training type.");

    //     // window.dispatchEvent(
    //     //     new CustomEvent("ai-suggest-options", {
    //     //         detail: { type: "trainingType" }
    //     //     })
    //     // );
    //     return;
    // }

    // Trainer
    if (!pending.trainer) {
        pushAIChat("Who is the trainer?");
        speak("Who is the trainer?");

        window.dispatchEvent(
            new CustomEvent("ai-suggest-options", {
                detail: { type: "employee_trainer" }
            })
        );
        return;
    }

    // Attendees (typed + multi select)
    if (!pending.Attendees || pending.Attendees.length === 0) {
        const names = text
            .split(/,|and/)
            .map(n => n.trim().toLowerCase())
            .filter(Boolean);

        if (names.length > 0) {
            const matchedEmployees = helpers.activeEmployee.filter((e: any) =>
                names.some(n =>
                    `${e.FirstName} ${e.LastName}`
                        .toLowerCase()
                        .includes(n)
                )
            );

            if (matchedEmployees.length > 0) {
                setPendingTraining({
                    ...pending,
                    Attendees: matchedEmployees.map(e => e.EmployeeID)
                });

                pushAIChat(
                    `Added attendees: ${matchedEmployees
                        .map(e => `${e.FirstName} ${e.LastName}`)
                        .join(", ")}`
                );
                speak("Attendees added.");
                return;
            }
        }

        // fallback → UI multi-select
        pushAIChat("Select attendees for this training.");
        speak("Select attendees for this training.");

        window.dispatchEvent(
            new CustomEvent("ai-suggest-options", {
                detail: { type: "employee_multi" }
            })
        );
        return;
    }

    // mode
    if (!pending.mode) {
        const lower = text.toLowerCase();

        if (lower.includes("online")) {
            setPendingTraining({ ...pending, mode: "online" });
            pushAIChat("What is the training cost?");
            speak("What is the training cost?");
            return;
        }

        if (lower.includes("offline")) {
            setPendingTraining({ ...pending, mode: "offline" });
            pushAIChat("Where is the training location?");
            speak("Where is the training location?");
            return;
        }

        pushAIChat("Is this training Online or Offline?");
        speak("Is the training online or offline?");
        return;
    }

    // Location (only if offline)
    if (pending.mode === "offline" && !pending.location) {
        setPendingTraining({ ...pending, location: text });
        pushAIChat("What is the training cost?");
        speak("What is the training cost?");
        return;
    }


    // Training Cost
    if (pending.trainingCost == null) {
        const cleaned = text.replace(/[^\d]/g, "");
        const cost = Number(cleaned);

        if (!cleaned || isNaN(cost) || cost <= 0) {
            pushAIChat("Please provide a valid training cost.");
            speak("Please provide a valid training cost.");
            return;
        }

        setPendingTraining({ ...pending, trainingCost: cost });

        // 👉 MOVE FLOW FORWARD
        pushAIChat("When does the training start?");
        speak("When does the training start?");
        return;
    }

    // 8️⃣ Start Date
    if (!pending.StartDate) {
        setPendingTraining({ ...pending, StartDate: text });
        pushAIChat("When does the training end?");
        speak("When does the training end?");
        return;
    }

    // 9️⃣ End Date
    if (!pending.EndDate) {
        setPendingTraining({ ...pending, EndDate: text });
        pushAIChat("status is active or inactive?");
        speak("status is active or inactive?");
        return;
    }

    // 🔟 Status
    if (!pending.Status) {
        const lower = text.toLowerCase();

        if (!lower.includes("active") && !lower.includes("inactive")) {
            pushAIChat("Please say active or inactive.");
            speak("Please say active or inactive.");
            return;
        }

        const status = lower.includes("inactive") ? "inactive" : "active";

        setPendingTraining({ ...pending, Status: status });

        // 🚀 FINAL CREATE
        pushAIChat(`Creating training "${pending.Name}" now...`);
        speak(`Creating training ${pending.Name}`);

        window.dispatchEvent(
            new CustomEvent("ai-create-training", { detail: { ...pending, Status: status } })
        );

        setPendingTraining(null);
        return;
    }

};

export const startDeleteTrainingFlow = (
    setPendingDelete: (data: PendingDeleteTraining | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    // ✅ If name already detected by intent
    if (nameFromIntent) {
        pushAIChat(`Deleting training "${nameFromIntent}"...`);
        speak(`Deleting training ${nameFromIntent}`);

        window.dispatchEvent(
            new CustomEvent("ai-delete-training", {
                detail: { name: nameFromIntent }
            })
        );
        return;
    }

    // ❓ Ask user
    setPendingDelete({ awaitingName: true });
    pushAIChat("Which training do you want to delete?");
    speak("Which training do you want to delete?");
};

export const processPendingDeleteTraining = (
    text: string,
    pendingDelete: PendingDeleteTraining,
    setPendingDelete: (data: PendingDeleteTraining | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    if (!pendingDelete?.awaitingName) return;

    const cleanName = text.replace(/[^a-zA-Z0-9 ]/g, "").trim();

    if (!cleanName) {
        pushAIChat("Please provide a valid training name.");
        speak("Please provide a valid training name.");
        return;
    }

    pushAIChat(`Deleting training "${cleanName}"...`);
    speak(`Deleting training ${cleanName}`);

    // 🔥 SINGLE, SAFE DISPATCH
    window.dispatchEvent(
        new CustomEvent("ai-delete-training", {
            detail: { name: cleanName }
        })
    );

    // ✅ CLEAR STATE (prevents duplicate delete)
    setPendingDelete(null);
};

